import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { parseReportState, serializeReportState, type ReportQueryState } from './report-utils';

export function useReportState(): [ReportQueryState, (next: ReportQueryState) => void] {
  const [params, setParams] = useSearchParams();
  const state = useMemo(() => parseReportState(params), [params]);
  const setState = useCallback((next: ReportQueryState) => {
    setParams(serializeReportState(next), { replace: true });
  }, [setParams]);
  return [state, setState];
}
